/** Desktop main nav row hover (top-level menus only, not dropdown panels). */
export const NAVIGATION_BAR_HOVERED = 'Navigation Bar Hovered';

export function navigationBarHoveredEventProperties(menuName: string): Record<string, string> {
  return {
    'Menu Name': menuName,
  };
}
